export const MenuList = [
  //Dashboard
  // {
  //   title: "Dashboard",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-networking"></i>,
  //   to: "/dashboard",
  // },
  // {
  //   title: "User Management",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-user-9"></i>,
  //   to: "/user-management",
  // },
  // {
  //   title: "Category",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#A60000"}} className="flaticon-381-list-1"></i>,
  //   to: "/category",
  // },
  // {
  //   title: "Events",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-menu"></i>,
  //   to: "/job-posting",
  // },

     {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-menu-1"></i>,
    to: "/dashboards",
  },
   {
    title: "Services",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-menu"></i>,
    to: "/services",
  },


  

    {
    title: "Admins",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-user-2"></i>,
    to: "/admins",
  },


    {
    title: "Education",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-folder-6"></i>,
    to: "/education",
  },
  {
    title: "Search",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-search-1"></i>,
    to: "/search",
  },
  {
    title: "FAQS",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-networking"></i>,
    to: "/faqs",
  },
   {
    title: "Appointments",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-networking"></i>,
    to: "/appointments",
  },
 
   {
    title: "Legal Info",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-panel"></i>,
    to: "/legal-info",
  },

   {
    title: "Resources",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-menu-1"></i>,
    to: "/resources",
  },
  
  
 {
    title: "Cases",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-menu-1"></i>,
    to: "/cases",
  },
   {
    title: "Terms & Condtion",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-paperclip"></i>,
    to: "/terms-condition",
  },

   {
    title: "Privacy Policy",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-padlock-2"></i>,
    to: "/privacy-policy",
  },


    {
    title: "Promotion",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-promotion-1"></i>,
    to: "/promotion",
  },

   {
    title: "About",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#0AB7EA"}} className="flaticon-381-id-card"></i>,
    to: "/about",
  },
   

  // {
  //   title: "Service Posting",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#A60000"}} className="flaticon-381-list"></i>,
  //   to: "/service-posting",
  // },
  // {
  //   title: "Price",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#A60000"}} className="flaticon-381-menu"></i>,
  //   to: "/price",
  // },
  // {
  //   title: "Report",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i style={{color:"#A60000"}} className="flaticon-381-menu"></i>,
  //   to: "/report",
  // },
];
